export default __webpack_public_path__ + "static/wbd_horizontal_logo_black-9b122b7dde0f18d81795b76dbc964a58.png";